module.exports = __webpack_public_path__ + "img/simon_zsuzsanna_reszketes_1.d2704f43.jpg";